module.exports = new __parcel__URL__("story.c031d198.svg").toString();